import { useEffect, useState } from "react";

import { memberAPI } from "../../utility/axios";
import useAzureAuthentication from "../../hooks/useAzureAuthentication";

export function AccountRankSelector(props) {
  const [accountRank, setAccountRank] = useState([]);

  let { authInfo } = useAzureAuthentication();


  useEffect(() => {
    let data = [
        { label: "0", value: "", text:"" },
        { label: "1", value: "0", text:"A" },
        { label: "2", value: "1", text:"B" },
        { label: "3", value: "2", text:"C" },
        { label: "4", value: "6", text:"C1" },
        { label: "5", value: "7", text:"C2" },
        { label: "6", value: "8", text:"C3" },
        { label: "7", value: "5", text:"S" },
        { label: "8", value: "4", text:"P" },
    ]
      setAccountRank(data);
  }, [props.selectedAccountRank]);

  return (
    <div className="mb-3 row">
      <label className="col-sm-2 col-form-label-sm" htmlFor={props.id}>
        {props.label}
      </label>
      <div className="col-sm-3">
        <select
          id={props.id}
          onChange={props.onChange}
          className="form-select form-select-sm"
          value={props.selectedAccountRank}
          required = {props.required}
          disabled={props.disabled}
        >
          <option value="">{"<--Not Selected-->"}</option>
          {accountRank.map((accountRank, i) => {
            return (
              <option key={i} value={accountRank.value}>
                {accountRank.text}
              </option>
            );
          })}
        </select>
        <div className="invalid-feedback">Please select a rank</div>
      </div>
    </div>
  );
}
